export default __webpack_public_path__ + "static/media/satellite-data.96557507.svg";